import { cell, pickField } from "@/utility/fclReportFieldUtils";
import {
    clipText,
    dateReportCol,
    pickSort,
    reportCol,
} from "./importReportColumnUtils";

export const IMPORT_DEMURRAGE_LIST_COLUMNS = [
    reportCol({
        key: "hblNo",
        label: "HBL NO",
        width: 140,
        sticky: "left",
        render: (row) => clipText(pickField(row, ["hblNo", "HblNo", "hbL_Number", "HBLNumber"])),
        sortValue: (row) => pickSort(row, ["hblNo", "HblNo", "hbL_Number", "HBLNumber"]),
    }),
    reportCol({
        key: "carrierMBLNo",
        label: "CARRIER MBL NO.",
        width: 155,
        render: (row) =>
            clipText(pickField(row, ["carrierMBLNo", "CarrierMBLNo", "mblNo", "MblNo", "MBLNumber"])),
        sortValue: (row) =>
            pickSort(row, ["carrierMBLNo", "CarrierMBLNo", "mblNo", "MblNo", "MBLNumber"]),
    }),
    reportCol({
        key: "shipper",
        label: "SHIPPER",
        width: 200,
        render: (row) => clipText(pickField(row, ["shipper", "Shipper"])),
        sortValue: (row) => pickSort(row, ["shipper", "Shipper"]),
    }),
    reportCol({
        key: "vessel",
        label: "VESSEL",
        width: 160,
        render: (row) => clipText(pickField(row, ["vessel", "Vessel", "vesselName", "VesselName"])),
        sortValue: (row) => pickSort(row, ["vessel", "Vessel", "vesselName", "VesselName"]),
    }),
    reportCol({
        key: "containerNo",
        label: "CONTAINER #",
        width: 165,
        render: (row) =>
            clipText(
                pickField(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"])
            ),
        sortValue: (row) =>
            pickSort(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"]),
    }),
    reportCol({
        key: "carrier",
        label: "CARRIER",
        width: 140,
        render: (row) =>
            clipText(pickField(row, ["carrier", "Carrier", "carrierName", "CarrierName"])),
        sortValue: (row) => pickSort(row, ["carrier", "Carrier", "carrierName", "CarrierName"]),
    }),
    reportCol({
        key: "pol",
        label: "POL",
        width: 120,
        render: (row) =>
            clipText(pickField(row, ["pol", "POL", "polCustomized", "PolCustomized", "portOfLoading"])),
        sortValue: (row) =>
            pickSort(row, ["pol", "POL", "polCustomized", "PolCustomized", "portOfLoading"]),
    }),
    reportCol({
        key: "pod",
        label: "POD",
        width: 120,
        render: (row) =>
            clipText(pickField(row, ["pod", "POD", "podCustomized", "PodCustomized", "portOfDischarge"])),
        sortValue: (row) =>
            pickSort(row, ["pod", "POD", "podCustomized", "PodCustomized", "portOfDischarge"]),
    }),
    dateReportCol({
        key: "ets",
        label: "ETS",
        fieldKeys: ["ets", "ETS", "etspol", "ETSPOL"],
        width: 118,
    }),
    dateReportCol({
        key: "eta",
        label: "ETA",
        fieldKeys: ["eta", "ETA", "etapod", "ETAPOD"],
        width: 118,
    }),
    dateReportCol({
        key: "lastFreeDate",
        label: "LAST FREE DATE",
        fieldKeys: [
            "lastFreeDate",
            "LastFreeDate",
            "lastFreeDay",
            "LastFreeDay",
            "lfd",
            "LFD",
        ],
        width: 130,
    }),
    reportCol({
        key: "noOfDays",
        label: "NO. OF DAYS",
        width: 110,
        align: "center",
        render: (row) =>
            clipText(
                pickField(row, [
                    "noOfDays",
                    "NoOfDays",
                    "demurrageDays",
                    "DemurrageDays",
                    "days",
                    "Days",
                ]),
                "text-[12px] font-semibold tabular-nums"
            ),
        sortValue: (row) =>
            pickSort(row, [
                "noOfDays",
                "NoOfDays",
                "demurrageDays",
                "DemurrageDays",
                "days",
                "Days",
            ]),
        getTooltip: (row) =>
            cell(
                pickField(row, [
                    "noOfDays",
                    "NoOfDays",
                    "demurrageDays",
                    "DemurrageDays",
                    "days",
                    "Days",
                ])
            ),
    }),
];

/** @deprecated Use IMPORT_DEMURRAGE_LIST_COLUMNS */
export const IMPORT_DEMURRAGE_COLUMNS = IMPORT_DEMURRAGE_LIST_COLUMNS;
